module.exports = __webpack_public_path__ + "static/media/shopping-icon.96113fca.png";